import rules from "../rules";
import { i18n } from "../translate/i18n";

function normalizeText(value) {
	return (value || "")
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "");
}

function canViewAdmin(profile) {
	return Boolean(rules[profile]?.static?.includes("drawer-admin-items:view"));
}

export function getAppSearchableNavItems() {
	const items = [
		{
			id: "dashboard",
			path: "/",
			label: "Dashboard",
			keywords: ["dashboard", "painel", "inicio", "home"],
		},
		{
			id: "tickets",
			path: "/tickets",
			label: () => i18n.t("mainDrawer.listItems.tickets"),
			keywords: ["conversas", "tickets", "chat", "whatsapp", "atendimento"],
		},
		{
			id: "social-comments",
			path: "/social-comments",
			label: () => i18n.t("mainDrawer.listItems.socialComments"),
			keywords: [
				"comentarios",
				"comments",
				"facebook",
				"instagram",
				"social",
				"feed",
				"posts",
			],
		},
		{
			id: "schedules",
			path: "/schedules",
			label: () => i18n.t("mainDrawer.listItems.schedules"),
			keywords: ["agendamentos", "agenda", "schedules"],
		},
		{
			id: "google-agenda",
			path: "/google-agenda",
			label: () => i18n.t("mainDrawer.listItems.googleAgenda"),
			keywords: ["google", "calendar", "gcal", "google agenda"],
		},
		{
			id: "contacts",
			path: "/contacts",
			label: () => i18n.t("mainDrawer.listItems.contacts"),
			keywords: ["contatos", "contacts", "clientes"],
		},
		{
			id: "quickAnswers",
			path: "/quickAnswers",
			label: () => i18n.t("mainDrawer.listItems.quickAnswers"),
			keywords: ["respostas", "rapidas", "atalhos", "quick"],
		},
		{
			id: "documentation",
			path: "/documentacao",
			label: () => i18n.t("mainDrawer.listItems.documentation"),
			keywords: ["informativos", "documentacao", "avisos", "meta", "docs"],
		},
		{
			id: "bulk",
			path: "/bulk-messaging",
			label: "Envio em massa",
			keywords: ["envio", "massa", "bulk", "campanha"],
		},
		{
			id: "tags",
			path: "/tags",
			label: () => i18n.t("mainDrawer.listItems.tags"),
			keywords: ["etiquetas", "tags", "marcadores"],
		},
	];

	const adminItems = [
		{
			id: "connections",
			path: "/connections",
			label: () => i18n.t("mainDrawer.listItems.connections"),
			keywords: ["conexoes", "whatsapp", "canais", "connections"],
			adminOnly: true,
		},
		{
			id: "sales-funnel",
			path: "/sales-funnel",
			label: "Funil de vendas",
			keywords: ["funil", "vendas", "crm"],
			adminOnly: true,
		},
		{
			id: "agent-ia",
			path: "/AgenteIa",
			label: "Agente IA",
			keywords: ["agente", "ia", "inteligencia", "bot"],
			adminOnly: true,
		},
		{
			id: "trigger-funnels",
			path: "/triggerFunnels",
			label: "Gatilhos para Funis",
			keywords: ["gatilhos", "funis", "trigger"],
			adminOnly: true,
		},
		{
			id: "avaliations",
			path: "/avaliations",
			label: "Avaliações",
			keywords: ["avaliacoes", "feedback", "nota"],
			adminOnly: true,
		},
		{
			id: "whatsappMetrics",
			path: "/whatsapp-metrics",
			label: "Métricas WhatsApp",
			keywords: [
				"meta",
				"volume",
				"template",
				"anuncio",
				"anúncio",
				"custo",
				"whatsapp oficial",
			],
			adminOnly: true,
		},
		{
			id: "reports",
			path: "/reports",
			label: "Relatórios",
			keywords: ["relatorios", "reports", "estatisticas"],
			adminOnly: true,
		},
		{
			id: "adminAiReports",
			path: "/admin-ai-reports",
			label: () => i18n.t("adminAiReports.title"),
			keywords: [
				"relatorio ia",
				"relatório ia",
				"admin ai",
				"inteligencia artificial",
				"desempenho",
				"atendentes",
			],
			adminOnly: true,
		},
		{
			id: "users",
			path: "/users",
			label: () => i18n.t("mainDrawer.listItems.users"),
			keywords: ["usuarios", "users", "equipe"],
			adminOnly: true,
		},
		{
			id: "queues",
			path: "/Queues",
			label: () => i18n.t("mainDrawer.listItems.queues"),
			keywords: ["setores", "filas", "queues"],
			adminOnly: true,
		},
		{
			id: "follow-up",
			path: "/FollowUp",
			label: () => i18n.t("mainDrawer.listItems.followUp"),
			keywords: ["followup", "follow-up", "inatividade", "lembrete", "silencio"],
			adminOnly: true,
		},
		{
			id: "templates",
			path: "/Templates",
			label: "Templates",
			keywords: ["templates", "modelos", "mensagens"],
			adminOnly: true,
		},
		{
			id: "integrations",
			path: "/integrations",
			label: () => i18n.t("integrations.title"),
			keywords: ["integracoes", "asaas", "google", "api"],
			adminOnly: true,
		},
		{
			id: "transactions",
			path: "/transactions",
			label: () => i18n.t("transactions.title"),
			keywords: ["transacoes", "asaas", "pix", "pagamentos", "cobrancas"],
			adminOnly: true,
		},
		{
			id: "settings",
			path: "/Settings",
			label: () => i18n.t("mainDrawer.listItems.settings"),
			keywords: ["configuracoes", "settings", "sistema"],
			adminOnly: true,
		},
	];

	return [...items, ...adminItems];
}

export function getMasterSearchableNavItems() {
	return [
		{
			id: "master-home",
			path: "/admin-master",
			label: () => i18n.t("master.nav.dashboard"),
			keywords: ["master", "painel", "dashboard"],
		},
		{
			id: "master-companies",
			path: "/admin-master/companies",
			label: () => i18n.t("master.nav.companies"),
			keywords: ["empresas", "companies", "clientes"],
		},
		{
			id: "master-plans",
			path: "/admin-master/plans",
			label: () => i18n.t("master.nav.plans"),
			keywords: ["planos", "plans", "tokens", "preco"],
		},
		{
			id: "master-addons",
			path: "/admin-master/addons",
			label: () => i18n.t("master.nav.addons"),
			keywords: ["addons", "compras", "avulsas", "pacotes", "tokens"],
		},
		{
			id: "master-coupons",
			path: "/admin-master/coupons",
			label: () => i18n.t("master.nav.coupons"),
			keywords: ["cupons", "coupons", "desconto", "promo"],
		},
		{
			id: "master-system",
			path: "/admin-master/system",
			label: () => i18n.t("master.nav.system"),
			keywords: ["sistema", "servidor", "analise"],
		},
		{
			id: "master-documents",
			path: "/admin-master/documents",
			label: () => i18n.t("master.nav.documents"),
			keywords: ["informativos", "documentacao", "avisos", "meta", "docs"],
		},
		{
			id: "master-users",
			path: "/admin-master/busca/usuarios-por-empresa",
			label: () => i18n.t("master.nav.searchUsers"),
			keywords: ["usuarios", "empresa", "busca"],
		},
		{
			id: "master-schedule-logs",
			path: "/admin-master/agendamentos/logs",
			label: () => i18n.t("master.nav.scheduleLogs"),
			keywords: ["agendamento", "schedule", "logs", "erro", "fila"],
		},
		{
			id: "master-bulk-logs",
			path: "/admin-master/envio-massa/logs",
			label: () => i18n.t("master.nav.bulkMessagingLogs"),
			keywords: ["bulk", "massa", "envio", "logs", "campanha", "erro"],
		},
	];
}

export function filterNavItems(items, query, { isAdmin } = {}) {
	const q = normalizeText(query);
	if (!q) return [];

	return items
		.filter((item) => !item.adminOnly || isAdmin)
		.map((item) => {
			const label = typeof item.label === "function" ? item.label() : item.label;
			const haystack = normalizeText(
				[label, item.path, ...(item.keywords || [])].join(" ")
			);
			return { ...item, label, haystack };
		})
		.filter((item) => item.haystack.includes(q))
		.slice(0, 12);
}

export function filterNavItemsForUser(user, query, variant = "app") {
	const isAdmin = canViewAdmin(user?.profile);
	const items =
		variant === "master" ? getMasterSearchableNavItems() : getAppSearchableNavItems();
	return filterNavItems(items, query, { isAdmin });
}

export { normalizeText, canViewAdmin };
